module.exports = __webpack_public_path__ + "generate-dkim-icon.svg?b36cc31e90a99644fda40142e96d83e9";